// Presentation-only classification. Values remain in the existing form/API
// contract; hiding a value does not remove it from API responses or memory.
export const isSecretAgentSetting = (key, schema = {}) => {
  if (
    schema.writeOnly === true ||
    schema.format === "password" ||
    schema.type === "password"
  ) {
    return true;
  }

  const normalized = String(key)
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/[-\s]+/g, "_")
    .toLowerCase();
  return (
    /(?:^|_)(?:password|passwd|passphrase|secret|token)(?:_|$)/.test(
      normalized,
    ) ||
    /^(?:(?:api|private|encryption|signing|session|auth)_?key|pin|credential|credentials|key)$/.test(
      normalized,
    )
  );
};

export const maskAgentSetting = (key, value, schema = {}) => {
  if (isSecretAgentSetting(key, schema)) {
    return value == null || value === "" ? "" : "••••••••";
  }
  if (Array.isArray(value)) {
    return value.map((item) => maskAgentSetting("", item, schema.items));
  }
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([name, item]) => [
        name,
        maskAgentSetting(name, item, schema.properties?.[name]),
      ]),
    );
  }
  return value;
};

// Backend result/message bodies can echo credentials. These flows already have
// translated fallback messages; only the numeric status is safe for feedback.
export const agentErrorForFeedback = (error) => ({
  ...(Number.isInteger(error?.status) ? { status: error.status } : {}),
});

// Only existing translated provider error codes may cross into user feedback.
const CONFIGURATION_ERROR_CODES = new Set([
  "pending_oauth",
  "missing_access_token",
  "invalid_access_token",
  "revoked_by_user",
  "auth_type_changed",
  "logged_out",
  "missing_phone_number_id",
  "missing_pin",
  "invalid_pin",
  "pin_rate_limited",
  "phone_reverification_needed",
  "phone_not_registered",
  "certificate_error",
  "account_blocked",
  "registration_failed",
  "pending_registration",
  "registration_rate_limited",
]);

export const agentConfigurationErrorKey = (code) =>
  CONFIGURATION_ERROR_CODES.has(code)
    ? `whatsappOAuth.errors.${code}`
    : "whatsappOAuth.status.error";
